import { Loader2 } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";

interface RecipeListPaginationProps {
  totalCount: number;
  pageNumber: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isRefreshing?: boolean;
}

const RecipeListPagination = ({
  totalCount,
  pageNumber,
  totalPages,
  onPageChange,
  isRefreshing = false
}: RecipeListPaginationProps) => (
  <div className="tw-flex tw-items-center tw-justify-between tw-mt-3">
    <div className="tw-flex tw-items-center tw-gap-2">
      <p className="tw-text-xs tw-text-muted-foreground">
        {totalCount} recipe{totalCount !== 1 ? "s" : ""} found
      </p>
      {isRefreshing && (
        <span className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-text-primary">
          <Loader2 className="tw-h-3.5 tw-w-3.5 tw-animate-spin" />
          Loading...
        </span>
      )}
    </div>
    {totalPages > 1 && (
      <div className="tw-flex tw-items-center tw-gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={isRefreshing || pageNumber <= 1}
          onClick={() => onPageChange(pageNumber - 1)}
        >
          Previous
        </Button>
        <span className="tw-text-sm tw-text-muted-foreground">
          Page {pageNumber} of {totalPages}
        </span>
        <Button
          variant="outline"
          size="sm"
          disabled={isRefreshing || pageNumber >= totalPages}
          onClick={() => onPageChange(pageNumber + 1)}
        >
          Next
        </Button>
      </div>
    )}
  </div>
);

export default RecipeListPagination;
